const create = {
  path: 'create',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/shopCodeAlipay/accessPay/create'], resolve)
}

export default create
